<div class="modal-header">
    <h3 class="modal-title">{{'interviews.Feedback Requested Title' | translate}}</h3>
</div>
<div class="modal-body">
    <div class="space-bottom-md text-center">
        <img width="64" height="64" src="/si_ei/images/notification_letter.gif" border="0" alt=""/>
    </div>
    <p class="text-center h3-text">{{'interviews.Feedback Sent' | translate}}</p>
    <p class="text-center body-small">{{'interviews.Feedback Sent Subtitle' | translate}}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn_secondary" (click)="activeModal.close()">{{'interviews.Close' | translate}}</button>
</div>